import styled from 'styled-components';

export const Section = styled.div.attrs({
  className: 'flex flex-col gap-1.5 w-full',
})``;

export const Heading = styled.p.attrs({
  className: 'text-xs font-semibold text-card-foreground w-full',
})``;

export const List = styled.div.attrs({
  className: 'flex flex-col gap-1.5 w-full',
})``;

export const Empty = styled.div.attrs({
  className: 'text-center text-muted-foreground py-4 w-full',
})``;
